<template> 
  <div>
    <div class="bet-list card hidden divide-y md:block">
      <div class="card-text flex flex-col gap-2">
        <div class="flex items-center justify-between gap-2">
          <div class="flex items-center gap-2">
            <svg
              data-v-aee14c88=""
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            ><path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
            ></path></svg> รายการแทง
          </div><div class="bet-count chip gap-1 overflow-hidden rounded-full">
            <span class="animate-slide-left font-semibold">{{ userSelect.length }}</span> รายการ
          </div>
        </div>
      </div>
      
      <div
        v-if="!userSelect.length"
        class="bet-not-found flex h-96 flex-col items-center justify-center gap-4"
      >
        <svg
          data-v-aee14c88=""
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
          class="h-16 w-16"
        ><path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
        ></path></svg> ไม่พบรายการ
      </div>
      
      <div
        v-if="userSelect.length"
        class="overflow-x-auto h-96 rounded-none"
      >
        <table class="relative w-full">
          <div
            v-for="(item, i) in numberConditions"
            v-show="dataFilter(item).length!==0"
            :key="i"
            class="w-full"
          >
            <thead class="header-table border-t first:border-t-0">
              <tr>
                <th class="py-1 w-full">
                  <div class="flex items-center gap-1">
                    {{ item.number_type.name }} 
                    <div class="v-popper v-popper--theme-tooltip">
                    </div>
                  </div>
                </th><th class="py-1 text-right text-sm">
                  {{ dataFilter(item).length }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(itemJ, j) in dataFilter(item)"
                :key="j"
                class="cursor-pointer"
              >
                <td>
                  <div class="flex items-center gap-1">
                    {{ itemJ.number }}
                  </div>
                </td>
                <td class="py-1 text-right">
                  <button
                    class="icon text error2"
                    type="button"
                    @click="delValue(itemJ)"
                  >
                    <div class="flex items-center justify-center">
                      <svg
                        data-v-aee14c88=""
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true"
                        class="h-5 w-5"
                      ><path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                      ></path></svg>
                    </div>
                  </button>
                </td>
              </tr>
            </tbody>
          </div>
        </table>
      </div>
      <div class="flex flex-col card-actions">
        <button
          id="buy-list-dialog-btn"
          class="w-full"
          type="button"
          :disabled="!userSelect.length"
          @click="showConfirm"
        >
          <div class="flex items-center justify-center">
            ส่งโพย
          </div>
        </button><svg
          data-v-aee14c88=""
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
          class="mx-auto"
        ><path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
        ></path></svg>
        
        <button
          id="buy-list-remove-btn"
          class="w-full bg-error/10 text-error"
          type="button"
          :disabled="!userSelect.length"
          @click="clearAlert"
        >
          <div class="flex items-center justify-center">
            ลบทั้งหมด
          </div>
        </button>
      </div>
    </div>

    <dialogconfirmaddstake 
      ref="confirmAddstake" 
      @load="load" 
    />

    <!-- <v-card
      flat
      class="mt-3 price-card"
    > 
      <dialogconfirmaddstake 
        ref="confirmAddstake" 
        @load="load" 
      />

      <div class="flex pa-3 gap-2 items-center font-basic">
        <icon-list class="icon"></icon-list>
        <span>รายการแทง</span> 
        <div class="bet-count chip gap-1 overflow-hidden rounded-full justify-self-center ml-auto">
          <span class="animate-slide-left font-semibold">0</span> รายการ
        </div>
      </div>

      <h6 class="ml-3">
        {{ $t('stake-same-price') }}
      </h6>
      <v-row
        no-gutters
        class="mt-3 mx-3"
      >
        <v-col cols="8">
          <n-number-field-specific
            v-model="allPrice"
            :placeholder="$t('placeholder.each-number')" 
            @keydown="preventNumber"
          />
        </v-col>
        <v-col class="mx-1">
          <v-btn
            height="40"
            depressed
            dark
            width="100%"
            color="#e89922"
            @click="removeSameNumber ()"
          >
            {{ $t('button.remove-duplicate') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-if="voucher.uuid"
        no-gutters
      >
        <v-col
          cols="12"
        >
          <v-list-item-title 
            class="px-3"
          >
            {{ $t('voucher-used') }} :
          </v-list-item-title>
          <v-list
            color="pink"
            dark
          >
            <v-list-item>
              <v-list-item-avatar>
                <v-img 
                  :src="voucher.image_url"
                /> 
              </v-list-item-avatar> 
              <v-list-item-content>
                <v-list-item-title>
                  {{ voucher.name }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="voucher.rules.stake_quota_limit">
                  {{ $t('max-stake') }} {{ voucher.rules.stake_quota_limit }} {{ $t('unit.credit') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="voucher.rules.stake_max_number">
                  {{ $t('max-number') }} {{ voucher.rules.stake_max_number }}  {{ $t('unit.amount') }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                {{ `x${voucher.amount}` }} 
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-divider class="my-1" />
     
      <resultlist  
        :number-conditions="numberConditions"
        :user-select="userSelect"
        :sum-user-price="sumUserPrice"
        :open-delete-row="delValue"
      />  
      <v-col 
        v-if="errorMessage" 
        class="text-end mr-3" 
      >
        <h5 class="red--text">
          {{ errorMessage }}
        </h5>
      </v-col> 
      <v-row 
        class="ma-1"
      > 
        <v-col
          v-if="isNotRoleUser"
          cols="12"
        >
          <n-text-field-noemoji
            v-model="description"  
            :placeholder="$t('placeholder.description')" 
            hide-details
          /> 
        </v-col>
        <v-col
          cols="3" 
        >
          <h6>{{ $t('total-all') }}</h6>
          <b>{{ total | currency }}</b>
        </v-col>
        <v-col 
          align="end"
        >
          <v-btn
            height="40"
            class="mr-1"
            outlined
            @click="clearAlert"
          >
            {{ $t('button.clear-all') }}
          </v-btn>
          <v-btn
            height="40"
            depressed
            color="blue"
            class="white--text"
            :disabled="submitStatus"
            :loading="submitStatus"
            @click=" addStake"
          >
            {{ $t('button.stake-bet') }}
          </v-btn>
        </v-col>
      </v-row> 
    </v-card>  -->
  </div>
</template>
<script>   
import dialogconfirmaddstake from '../childs/ConfirmAddStake'
// import resultlist from '../childs/ResultList'  
import { gameRooms as apiGameRooms } from '@/apis'
import { SPECIAL_ROLE_GROUP } from '@/const/roleId'
// import IconList from '@/components/Icon/IconList.vue'
export default {
  components : { 
    dialogconfirmaddstake, 
    // resultlist,
    // IconList
  },
  props : {
    numberConditions:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    },  
    voucher:{
      type:Object,
      default:()=>{}
    }
  },
  data () {
    return { 
      description:null,
      submitStatus:false, 
      total:0, 
      allPrice:'',
      errorMessage:null, 
    }
  }, 

  computed: { 
    creditAmount () {
      return (this.wallet || {}).amount || 0
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    userRoleId () {
      return ((this.userProfile || {}).role || {}).id
    },
    isNotRoleUser () {
      return SPECIAL_ROLE_GROUP.includes(this.userRoleId)
    },
    routeId () {
      return this.$route.query.id
    },
  },

  watch : {
    userSelect () { 
      this.errorMessage=''
      this.sumUserPrice()
    },
    allPrice () { 
      if(this.allPrice!==null){   
        this.allPriceList ()
      } 
    } 
  }, 
  methods : {  
    preventNumber (evt) { 
      if(parseInt(this.allPrice + evt.key) === 0) {
        evt.preventDefault()
        return
      }else if((this.allPrice || [])[0] && this.allPrice[0]==='0'){
        this.allPrice=1
        evt.preventDefault()
        return
      }
    },

    delValue (number){  
      this.$ga.event('Button', 'DeleteStakeWeb', 'ResultSelectBet', number)

      this.$emit('delValue',
        null,
        number.number,
        number.number_type_id,
        number.selectNineteen,
        number.selectFrontRoot,
        number.selectBackRoot)

      // this.$confirm('',this.$t('confirm.cancel-this-number'),'warning').then(()=>{ 
      //   this.errorMessage = ''
        
      // }).catch(()=>{}); 
    },  

    async addStake () { 
      var entireStake = []
      var breakStatus = false
      this.submitStatus = true
      this.$ga.event('Submit', 'AddStakeWeb', 'ResultSelectBet', '')
      let stakeQuotaLimit = (this.voucher.rules || {}).stake_quota_limit
      let checkVoucherStakeTotal = this.voucher.rules && stakeQuotaLimit
      
      this.numberConditions.forEach(cond => {
        const items = this.userSelect.filter(x=> x.number_type_id === cond.number_type.id)
        const lengthPerCondition = (items || []).length
        //check max number list per number condition
        if(cond.max_unit_per_number_per_list && cond.max_unit_per_number_per_list < lengthPerCondition) { 
          breakStatus = true
          this.errorMessage=`${cond.number_type.name} ${this.$t('validate.maximun-stake-is')} ${cond.max_unit_per_number_per_list} ${this.$t('unit.unit-per-number-per-list')}`
          return
        }

        //check max number user per number condition
        if(cond.max_number_per_user && cond.max_number_per_user < lengthPerCondition) { 
          breakStatus = true
          this.errorMessage=`${cond.number_type.name} ${this.$t('validate.maximun-stake-is')} ${cond.max_number_per_user} ${this.$t('unit.number-per-user')}`
          return
        }

        items.forEach(element=>{ 
          //check empty field
          if(!breakStatus && (element.unit === null || element.unit==='')) { 
            breakStatus = true
            this.errorMessage=`${this.$t('validate.please-enter-number-numbers')} ${element.number}`
            return
          }   

          // totalPerCondition += parseInt(element.unit || 0)
          entireStake.push({
            number:element.number,
            number_type_id:element.number_type_id,
            unit:element.unit
          }) 
        }) 
      }) 

      await Promise.all(entireStake)

      if(breakStatus) { 
        this.submitStatus = false 
        return
      } 
      
      if(checkVoucherStakeTotal && this.total > parseInt(stakeQuotaLimit)) {
        this.errorMessage=` ${this.$t('number-condition.maximum-bet')} ${stakeQuotaLimit} ${this.$t('unit.credit')}`
        this.submitStatus = false 
        return
      }

      if(entireStake.length===0){
        this.errorMessage= this.$t('validate.please-choose-bet-number')
        this.submitStatus = false
      } else if(this.creditAmount - this.total<0){
        this.errorMessage=this.$t('validate.money-not-enough')
        this.submitStatus = false
      } else {
        this.apiaddStake(this.routeId,entireStake) 
      }  
    }, 

    async apiaddStake (id,stakes){  
      let params = {
        stakes:stakes
      }
      if(this.voucher.uuid) {
        params.voucher_uuid = this.voucher.uuid
      }
      if(this.description){
        params.description = this.description
      } 
      const [err,data] = await apiGameRooms.postAddStake(id,params)
      this.submitStatus = false
      
      if(err){
        this.$alert('',err,'warning') 
        return
      }
 
      if(data) {
        this.$refs.confirmAddstake.openDialog(data,this.numberConditions)   
      } 
    }, 

    removeSameNumber () {  
      this.$ga.event('Button', 'RemoveSameNumberWeb', 'ResultSelectBet', '')
      this.errorMessage = ''
      this.$emit('removeSameNumber')
    },

    findElement (id) { 
      return this.numberConditions.find(x=>x.number_type.id===id)
    },

    allPriceList () {
      this.errorMessage=''
      this.total = 0
      if(this.userSelect.length>0){
        this.userSelect.forEach(element => {
          var condition = this.findElement(element.number_type_id) 
          element.unit = condition.max_unit_per_number_per_list > this.allPrice ? this.allPrice : condition.max_unit_per_number_per_list
          if(element.unit!==null){
            this.total += element.unit*condition.price
          }
        }); 
      } 
    },

    sumUserPrice () { 
      this.total = 0  
      if(this.userSelect.length>0){ 
        this.userSelect.forEach(element => {  
          if(element.unit){
            this.total += parseInt(element.unit)*this.findElement(element.number_type_id).price 
          } 
        }); 
      } 
    }, 

    clearAlert () {
      this.$ga.event('Button', 'ClearAllWeb', 'ResultSelectBet', '')
      this.$confirm('',this.$t('confirm.remove-all-stake-list'),'warning').then(()=>{ 
        this.clearAll()
      }).catch(()=>{}); 
    },

    load () {
      this.clearAll()
      this.$emit('load') 
    },

    clearAll () { 
      this.allPrice = ''
      this.errorMessage = ''
      this.total = 0
      this.$emit('clearAll') 
    }, 

    dataFilter (item){ 
      return item.number_type ?
        this.userSelect.filter(x=>x.number_type_id===item.number_type.id)
        : [] 
        // .sort((a,b) => a.number - b.number)
    },

    showConfirm () {
      this.$emit('confirm')
    },
  }
}
</script>
<style scoped>
.price-card {
  border-radius: .5rem;
  background-color: var(--bg-secondary-color-v2);
}
.icon {
  width: 1.5rem;
  height: 1.5rem;
}

.bet-list {
  background-color: var(--bg-secondary-color-v2);
}

.bet-list .bet-count {
  --tw-text-opacity: 1;
  background: radial-gradient(ellipse at center top, #383838, #171717);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.card {
  border-radius: .5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
  height: auto;
}

.card .card-text {
  color: #374151;
  padding: .75rem;
  border-bottom: .5px solid #374151;
}

.card .card-actions, .card .card-text, .card .card-title {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}

.card .card-actions {
    padding: .75rem;
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}

.bet-list table thead th {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(46, 30, 30, 1);
}

.bet-list table tbody {
  background-color: var(--bg-primary-400);
}

table {
  border-collapse: collapse;
  border-color: inherit;
  text-indent: 0;
}

table thead tr th {
  --tw-bg-opacity: 1;
  background-color: rgba(46, 30, 30, 1);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  --tw-shadow: inset 0 -1px hsla(0, 0%, 100%, .1);
  --tw-shadow-colored: inset 0 -1px var(--tw-shadow-color);
}

table tbody tr:nth-child(2n) {
  background-color: var(--bg-primary-250);
}

.error2:hover {
  background-color: var(--bg-primary-550);
  border-radius: .2em;
}

.bet-list #buy-list-remove-btn {
  --tw-text-opacity: 1 !important;
  background: radial-gradient(ellipse at center top, #383838, #171717) !important;
  color: rgb(255 255 255/ 1) !important;
}

.bet-list #buy-list-dialog-btn {
  border-style: solid;;
  border-width: 1px !important;
  border-color: rgb(0 0 0/ 1) !important;
  color: rgb(0 0 0/ 1) !important;
  background-color: var(--bg-secondary-color-v2);
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: rgba(var(--color-primary));
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

#buy-list-dialog-btn:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  filter: brightness(.9);
}

.btn.icon, [type=button].icon, [type=submit].icon, button.icon {
  height: 2rem;
  min-height: 2rem;
  padding: 0;
  width: 2rem;
  color: black;
}

.btn .disabled, .btn:disabled, [type=button] .disabled, [type=button]:disabled, [type=submit] .disabled, [type=submit]:disabled, button .disabled, button:disabled {
  cursor: not-allowed !important;
  opacity: .5;
  pointer-events: none;
}

@media (min-width: 640px) {
  table tbody tr td, table thead tr th {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    padding: .5rem .75rem;
  }
}
</style>